// Asset and cart states as the UI names and colours them: one table each.

const ASSET_STATES = {
  ready: { label: "Ready", color: "#3DA46B" },
  processing: { label: "Processing", color: "#E6A23A" },
  error: { label: "Ingest failed", color: "#C23A2B" },
  archived: { label: "Archived", color: "#8A867F" },
};
// ponytail: no "live" state; no API status marks a growing file. Add one here (with a pulse) once it does.
const PROCESSING = ["UPLOADING", "PENDING", "TRANSCODING", "MOVING", "RESTORING"];
// The states that report a percentage.
const COUNTED = ["UPLOADING", "TRANSCODING"];
const STATUS_RANK = { error: 0, processing: 1, ready: 2, archived: 3 };

const CART_STATES = {
  NEW: { key: "neutral", label: "New", color: "#7C8190" },
  INPROGRESS: { key: "progress", label: "In progress", color: "#E6A23A" },
  SUBCLIPSSELECTED: { key: "restoring", label: "Queued", color: "#5AA8FF" },
  RENDERING: { key: "restoring", label: "Restoring", color: "#5AA8FF" },
  RESTORED: { key: "ready", label: "Restored", color: "#3DA46B" },
  APPROVED: { key: "ready", label: "Approved", color: "#3DA46B" },
  EMAILSENT: { key: "neutral", label: "Email sent", color: "#7C8190" },
  LOCKED: { key: "locked", label: "Locked", color: "#C23A2B" },
};
const NEUTRAL = "#7C8190";

function sentenceCase(text) {
  const lower = String(text || "").toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

function statusOf(asset) {
  return String((asset && asset.assetStatus) || "").toUpperCase();
}

/** Only on tape: the file left the disk (onTape without onDisk). */
export function isArchived(asset) {
  return !!asset && asset.onTape === true && asset.onDisk === false;
}

function assetKey(asset) {
  const status = statusOf(asset);
  if (status === "FAILED") return "error";
  if (PROCESSING.includes(status)) return "processing";
  return isArchived(asset) ? "archived" : "ready";
}

/** { key, label, color, detail }; detail is the tooltip, e.g. "Transcoding 42%". */
export function assetState(asset) {
  const key = assetKey(asset);
  const status = statusOf(asset);
  const percent = parseInt(asset && asset.progress, 10);
  let detail = ASSET_STATES[key].label;
  if (key === "processing") detail = sentenceCase(status) + (COUNTED.includes(status) && percent > 0 ? " " + percent + "%" : "");
  return { key, ...ASSET_STATES[key], detail };
}

/** Whether the proxy file exists. Without it FileServletApiImpl.fileServletProxyGet serves a dummy or a 404. */
export function hasProxy(asset) {
  if (!asset || asset.folder) return false;
  const key = assetKey(asset);
  return key === "ready" || key === "archived";
}

/** Ready is the normal case, so only the other states get a badge. */
export function showsStatus(asset) {
  return assetKey(asset) !== "ready";
}

/** Sort order for the Status sort: problems first. */
export function statusRank(asset) {
  return STATUS_RANK[assetKey(asset)];
}

/** { key, label, color }; no cart selected gives an empty label. */
export function cartState(cart) {
  const status = String((cart && cart.cartStatus) || "").toUpperCase();
  if (!status) return { key: "neutral", label: "", color: NEUTRAL };
  return CART_STATES[status] || { key: "neutral", label: sentenceCase(status), color: NEUTRAL };
}

// The three custom properties .pill, .pill-dot and .thumb-badge read.
export function pillStyle(color) {
  return `--pill:${color}; --pill-bg:${color}14; --pill-bd:${color}33`;
}

// Best-effort media kind from codec (no explicit field on the asset).
export function assetKind(asset) {
  const codec = String(asset?.codec || "").toUpperCase();
  if (/PCM|MP3|AAC|WAV|FLAC/.test(codec)) return "AUDIO";
  return "VIDEO";
}
